import { parse as parseYaml } from 'yaml';

const FRONTMATTER_RE = /^---\r?\n([\s\S]*?)\r?\n---\r?\n([\s\S]*)$/;

export const splitMarkdown = (raw: string): { data: Record<string, unknown>; content: string } => {
  const normalized = raw.startsWith('\uFEFF') ? raw.slice(1) : raw;
  const match = normalized.match(FRONTMATTER_RE);

  if (!match) {
    return { data: {}, content: normalized };
  }

  const [, yamlBlock = '', content = ''] = match;
  const data = parseYaml(yamlBlock) as Record<string, unknown> | null;

  return { data: data ?? {}, content };
};
